"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateSortHelper = DateSortHelper;
exports.StringSortHelper = StringSortHelper;
function formatDate(inputDate) {
  let formattedDate = inputDate;
  if (inputDate && inputDate.indexOf(' ') !== -1) {
    const [dateValue, timeValue, amPmValue] = inputDate.split(' ');
    if (dateValue && dateValue.indexOf('-') !== -1) {
      const [day, month, year] = dateValue.split('-');
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const updatedMonth = monthNames.indexOf(month) + 1 < 10 ? +'0' + String(monthNames.indexOf(month) + 1) : String(monthNames.indexOf(month) + 1);
      if (timeValue && timeValue.indexOf(':') !== -1) {
        formattedDate = new Date("".concat(year, "-").concat(updatedMonth, "-").concat(day));
        let [hours, minutes] = timeValue.split(':');
        if (hours === '12') {
          hours = '00';
        }
        if (amPmValue === 'PM') {
          hours = Number(hours, 10) + 12;
        }
        minutes = Number(minutes);
        formattedDate.setHours(hours, minutes);
      }
    }
  }
  return formattedDate;
}
function convertToLowerCase(inputString) {
  let lowerCaseString = inputString;
  if (inputString && inputString.length) {
    lowerCaseString = inputString.toLowerCase();
  }
  return lowerCaseString;
}
function StringSortHelper() {
  let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let property = arguments.length > 1 ? arguments[1] : undefined;
  let order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'upArrow';
  if (list.length) {
    list.sort((x, y) => {
      const a = convertToLowerCase(x[property]);
      const b = convertToLowerCase(y[property]);
      if (a < b) {
        return 1;
      }
      if (a > b) {
        return -1;
      }
      return 0;
    });
    if (order === 'downArrow') {
      list.reverse();
    }
  }
  return list;
}
function DateSortHelper() {
  let list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let property = arguments.length > 1 ? arguments[1] : undefined;
  let order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'upArrow';
  if (list.length) {
    list.sort((x, y) => {
      const a = new Date(formatDate(x[property]));
      const b = new Date(formatDate(y[property]));
      if (a < b) {
        return 1;
      }
      if (a > b) {
        return -1;
      }
      return 0;
    });
    if (order === 'downArrow') {
      list.reverse();
    }
  }
  return list;
}